import { ShareToClientModal } from '@/features/matchmaking/components/ShareToClientModal';
import { ReferralModal } from '../ReferralModal';

type ReferProviderDispatcherProps = {
  /** Engagement.clientUserId — null when the FP ran a client-agnostic Q&A. */
  engagementClientUserId: string | null;
  /** The provider whose Refer button was clicked (null = modal closed). */
  referProviderId: string | null;
  referProviderName: string;
  onOpenChange: (open: boolean) => void;
};

/**
 * Picks the right refer modal based on whether the engagement is bound
 * to a specific client. Client-bound engagements pre-fill that client
 * via the shared ShareToClientModal; client-agnostic ones open
 * ReferralModal which has its own multi-select client picker.
 */
export const ReferProviderDispatcher = ({
  engagementClientUserId,
  referProviderId,
  referProviderName,
  onOpenChange,
}: ReferProviderDispatcherProps) => {
  const isOpen = referProviderId !== null;
  if (engagementClientUserId) {
    return (
      <ShareToClientModal
        open={isOpen}
        onOpenChange={onOpenChange}
        providerId={referProviderId}
        providerName={referProviderName}
        clientId={engagementClientUserId}
      />
    );
  }
  return (
    <ReferralModal
      open={isOpen}
      onOpenChange={onOpenChange}
      providerId={referProviderId}
      providerName={referProviderName}
    />
  );
};
